import { createSelector } from 'reselect';

export const auth = (state: any) => state.auth;
export const authSelector = createSelector(auth, (data: any) => data);
